module.exports = __webpack_public_path__ + "assets/img/logo.bef1ef32.svg";